import { Link } from "react-router-dom";
import { ArrowRight, Leaf, TreePine, Smartphone, TrendingUp, CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { SEO } from "../components/SEO";
import { smartFeatures } from "../mockData";

export const SmartPlumbing = () => {
  return (
    <div className="min-h-screen bg-navy-900 pt-20">
      <SEO 
        title="Smart Plumbing | Magic C Plumbing | Plumber & Heating Engineer in London"
        description="Advanced smart plumbing features, energy monitoring, and connected systems for modern luxury homes and businesses. Maximize efficiency and control with cutting-edge technology."
        canonical="/smart-plumbing"
      />
      {/* Hero */}
      <section className="py-24 bg-gradient-to-b from-navy-900 to-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Smart Plumbing & Energy Efficiency
            </h1>
            <p className="text-2xl text-gray-300 leading-relaxed">
              Cutting-edge technology meets environmental responsibility for sustainable living
            </p>
          </div>
        </div>
      </section>

      {/* Smart Features Grid */}
      <section className="py-24 bg-navy-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
            {smartFeatures.map((feature) => {
              const IconComponent = { Leaf, TreePine, Smartphone, TrendingUp }[feature.icon];
              
              return (
                <Card key={feature.id} className="text-center bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all">
                  <CardContent className="p-10">
                    <div className="bg-gradient-to-br from-sage-500 to-sage-600 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                      <IconComponent className="h-12 w-12 text-white" />
                    </div>
                    <div className="text-5xl font-bold text-sage-400 mb-4">{feature.stat}</div>
                    <h3 className="text-2xl font-bold text-white mb-4">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white mb-12 text-center">
              Future-Proof Your Property
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                "Reduce water usage by up to 40%",
                "Lower energy bills with smart thermostats",
                "Real-time leak detection & instant alerts",
                "Remote system control via smartphone",
                "Automated water shut-off for emergencies",
                "Usage analytics and consumption reports",
                "Integration with home automation systems",
                "Predictive maintenance notifications"
              ].map((item, idx) => (
                <div key={`smart-item-${idx}`} className="flex items-start space-x-4 bg-white/5 p-6 rounded-xl backdrop-blur-md border border-white/10">
                  <CheckCircle className="h-7 w-7 text-sage-400 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-200 text-lg">{item}</span>
                </div>
              ))}
            </div>

            <div className="text-center mt-16">
              <Link to="/contact">
                <Button size="lg" className="bg-sage-600 hover:bg-sage-700 text-white text-lg px-10 py-7">
                  Request Smart System Consultation
                  <ArrowRight className="ml-2 h-6 w-6" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
